import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { RouteUnauthorized } from './route-unauthroized'
import { useLoginRedirect } from '../../layout/unauthorized/auth/hooks/redirect'

// Pages under /auth that a signed-in person legitimately uses: switching
// organization and reviewing invitations. Every other /auth page is a step of
// signing in (the account chooser, the SSO start, register, password
// recovery), and no step of signing in belongs in a signed-in layout.
// /auth/error stays: the impersonation sign-in reports its failure there
// while the admin is still signed in.
const SIGNED_IN_AUTH_PATHS = ['/auth/account', '/auth/invitations', '/auth/error']

export const isSignInStep = pathname =>
  !SIGNED_IN_AUTH_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`))

// /auth/* while signed in. An old history entry or a bookmark of a sign-in
// step goes straight to the return location (?redirect=) or the default home
// page, replacing the entry so Back does not come back to it.
export const SignedInAuthRoute = () => {
  const { pathname } = useLocation()
  const loginRedirect = useLoginRedirect()
  const leaving = isSignInStep(pathname)

  useEffect(
    () => {
      if (leaving) loginRedirect()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [leaving, pathname]
  )

  return leaving ? null : <RouteUnauthorized />
}
